<script setup lang="ts">
import Icon from '~/assets/images/icons/arrow_back.svg'

type Props = {
  size: number
}

defineProps<Props>()
</script>

<template>
  <div class="icon-wrapper">
    <Icon :height="size" :width="size" />
  </div>
</template>

<style scoped lang="scss">
.icon-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
